export default {
  metrics: {
    nrr: {
      title: 'NRR % (Trimestriel)',
      description:
        "(Chiffre d'affaires abonnements {{currentMonth}} (T{{currentQuarter}}) + Chiffre d'affaires frais de service {{currentMonth}} (T{{currentQuarter}})) / (Chiffre d'affaires abonnements {{prevMonth}} (fin T{{prevQuarter}}) + Chiffre d'affaires frais de service {{prevMonth}} (fin T{{prevQuarter}})) * 100",
    },
    upgrades: 'Mises à niveau de compte',
    downgrades: 'Rétrogradations de compte',
    gte_c_tier: 'Comptes ≥ Grade C',
    churn: 'Attrition (suspendu)',
    offers_turned_on: 'Offres activées',
    flyers_sent: 'Flyers envoyés',
    on_google_ads_trial: 'En essai Google Ads',
    converted_google_ads: 'Google Ads converti avec succès',
    first_time_500_monthly_sales: 'Premier mois à 500 €',
    '14_days_no_sales': '14 jours en ligne, aucun revenu',
  },
  details: {
    address: 'Adresse',
    subscriptions: 'Abonnements actuels',
    best_sales: 'Meilleur mois historique',
    sales: 'Ventes {{month}}',
    tier: 'Niveau {{month}}',
    live_from: 'Date de lancement',
    owner_phone: 'Téléphone du propriétaire',
    owner_email: 'E-mail du propriétaire',
    owner: 'Nom du propriétaire',
    name: 'Restaurant',
    export_csv: 'Exporter CSV',
  },
  publish: 'Publier',
  unpublish: 'Dépublier',
};
